import { EndpointType } from "@/graphql/__generated__/graphql-operations";
import { FormField } from "@/types";
import { FieldValues } from "react-hook-form";
import { FormGroupProps } from "../props";
import FormGroupWrapper from "./FormGroupWrapper";
import { JSX } from "react";

/**
 * Renders the Invoice Documentary form group.
 *
 * @template T - The type of field values.
 * @param {Props<T>} props - The component props.
 * @param {UseFormRegister<T>} props.register - The register function from react-hook-form.
 * @param {UseFormStateReturn<T>["errors"]} props.errors - The errors object from react-hook-form.
 * @param {UseFormWatch<T>} props.watch - The watch function from react-hook-form.
 * @returns {JSX.Element} - The rendered Asset Documentary form group.
 */
const InvoiceDocumentary = <T extends FieldValues>({ register, errors, watch, setValue }: FormGroupProps<T>): JSX.Element => {

  const formFields: FormField[] = [
    {
      key: "invoice-documentary-input-endpoint",
      name: "serviceproviderinput.invoicedocumentary.endpoint",
      type: "text",
      title: "Endpoint",
      required: true,
      placeholder: "Enter the endpoint URL",
    },
    {
      key: "invoice-documentary-input-authendpoint",
      name: "serviceproviderinput.invoicedocumentary.authendpoint",
      type: "text",
      title: "Auth Endpoint",
      required: true,
      placeholder: "Enter the auth endpoint URL",
    },
    {
      key: "invoice-documentary-input-username",
      name: "serviceproviderinput.invoicedocumentary.username",
      type: "text",
      title: "Username",
      required: true,
      placeholder: "Enter the username",
    },
    {
      key: "invoice-documentary-input-password",
      name: "serviceproviderinput.invoicedocumentary.password",
      type: "password",
      title: "Password",
      required: true,
      autoComplete: "new-password",
      placeholder: "Enter the password",
    },
    {
      key: "invoice-documentary-input-endpointType",
      name: "serviceproviderinput.invoicedocumentary.endpointType",
      isDropdown: true,
      title: "Endpoint Type",
      placeholder: "Select an endpoint type",
      required: true,
      dropdownOptions: [
        { text: "Coredinate", value: EndpointType.Coredinate },
        { text: "POP", value: EndpointType.Pop },
        { text: "Plentymarkets", value: EndpointType.Plentymarkets },
      ],
      defaultValue: "",
    },
  ];

  return (
    <FormGroupWrapper
      title="Invoice Documentary"
      register={register}
      errors={errors}
      watch={watch}
      setValue={setValue}
      formFields={formFields}
    />
  );
};

export default InvoiceDocumentary;
